import { Content } from '@ilteducation/content-registry-types';
import axios from 'axios';
import { useConfigHelper } from '@ilteducation/config';
import { SearchQuery, SearchResult, Filter, AggregationResult, GroupFilterMode } from './types';
import { getQueryString, getAggregateString } from './query-formatters';

const { getApiUrl } = useConfigHelper();

export const searchContent = (type: string, searchQuery: SearchQuery): Promise<SearchResult<Content>> => {
  const params = getQueryString(searchQuery);

  return axios
    .get(`${getApiUrl('content-search', true)}/${type}/search${params}`)
    .then((response) => response.data as SearchResult<Content>);
};

export const aggregateContent = (
  type: string,
  aggregateFields: string[],
  globalFilters: Filter,
  size = 1000000,
  query?: string,
  groupFilterMode?: GroupFilterMode,
): Promise<AggregationResult> => {
  const params = getAggregateString(aggregateFields, globalFilters, size, query, groupFilterMode);

  return axios
    .get(`${getApiUrl('content-search', true)}/${type}/aggr${params}`)
    .then((response) => response.data as AggregationResult);
};
